const PolicyResourceType = {
  PROJECTS: 'projects',
  DATASETS: 'datasets',
  POLICIES: 'policies',
} as const;
export type PolicyResourceTypeE = typeof PolicyResourceType[keyof typeof PolicyResourceType];

export default PolicyResourceType;
